import React from 'react';
import PropTypes from 'prop-types';

import {
    Alert,
    Anchor,
    Spacer,
    Text,
} from '@zillow/constellation';

const propTypes = {
    universal: PropTypes.object,
};

const defaultProps = {
    universal: null,
};

const ListingStatusBanner = ({ universal }) => {
    if (!universal || universal.partialMessages.length < 1) {
        return null;
    }

    const body = universal.partialMessages.map(({ url, text }, i) => (
        <Text key={`partial-message-${i}`} fontType="body">
            {url ? <Anchor key={i} href={url} target="_blank">{`${text} `}</Anchor> : `${text} `}
        </Text>
    ));

    return (
        <Spacer marginBottom="md">
            <Alert
                appearance="info"
                body={body}
            />
        </Spacer>
    );
};

ListingStatusBanner.propTypes = propTypes;
ListingStatusBanner.defaultProps = defaultProps;

export { ListingStatusBanner };
export default ListingStatusBanner;
